import { colorModeStorageKey } from '@lib/store/colorModeSlice';
import { useAppSelector } from '@lib/store/hooks';
import { store } from '@lib/store/store';
import { AppTheme } from '@theme/app-theme';
import { type ReactNode, useEffect } from 'react';
import { Provider } from 'react-redux';

const ColorModeSync = (): null => {
  const mode = useAppSelector((state) => state.colorMode.mode);

  useEffect(() => {
    document.documentElement.dataset.colorMode = mode;
    try {
      localStorage.setItem(colorModeStorageKey, mode);
    } catch {
      // The preference stays in memory when storage is blocked.
    }
  }, [mode]);

  return null;
};

interface AppStoreProviderProps {
  children: ReactNode;
}

export const AppStoreProvider = ({
  children,
}: AppStoreProviderProps): JSX.Element => {
  return (
    <Provider store={store}>
      <ColorModeSync />
      <AppTheme>{children}</AppTheme>
    </Provider>
  );
};
